import { Component, OnInit, Input, ViewChild, EventEmitter, OnChanges, Output, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { AgGridAngular } from '@ag-grid-community/angular';

import { WindowFactory } from '../../../window/services/window-factory.service';
import { BmGrid } from '../../classes/bm-grid';
import { OpenMethod } from '../../../shared/enums';
import { ColumnOptions } from '../../interfaces';
import { extractObject } from '../../../shared/utils';
import { GridActionHandler } from '../../classes/grid-action-handler.abstract';

@Component({
  selector: 'bm-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss']
})
export class GridComponent implements OnInit, OnChanges {


  @ViewChild(AgGridAngular, {static: false})
  agGrid: AgGridAngular;

  @Input() data: any;
  @Input() options: ColumnOptions[] = [];
  @Input() height: string | number = 'auto';

  @Output() rowClicked = new EventEmitter<any>();
  @Output() cellClicked = new EventEmitter<any>();

  rowData: any[];
  columnDefs: any[];
  summarizeRowData: any[];

  modules: any;
  frameworkComponents: any;

  constructor(@Optional() private gah: GridActionHandler) {}

  ngOnChanges() {

    const grid = new BmGrid(this.data, this.options);
    this.rowData = grid.getRowData();
    this.columnDefs = grid.getColumnDefs();
    this.summarizeRowData = grid.getSummarizeRowData();
    this.normalizeGrid();
  }

  ngOnInit() {
    this.modules = BmGrid.modules;
    this.frameworkComponents = BmGrid.frameworkComponents;
  }

  normalizeGrid() {
    if (!this.agGrid) {
      return;
    }

    const ids = this.agGrid.columnApi.getAllColumns().map(column => column.getColId());
    this.agGrid.columnApi.autoSizeColumns(ids);
  }


  onCellClicked(params) {

    this.gah.handleCellClick(params, this.options);
    this.cellClicked.emit(params);

  }

  onRowClicked(params) {

    this.gah.handleRowClick(params, this.options);
    this.rowClicked.emit(params);

  }

}


